export interface StoreBulkOperationValidateFileRequest {
  storeId: string;
  fileUrl: string;
  operationType: StoreBulkOperationType;
  additionalParams?: string;
}

export interface StoreBulkOperationResponse {
  message: string;
  hasErrors: boolean;
  operationType: StoreBulkOperationType;
  validationResult?: FileValidationResult;
  errors?: StoreBulkOperationErrorsDetails[];
}

export interface StoreBulkOperationResponseWithErrors {
  details: StoreBulkOperationErrorsDetails[];
}
export interface StoreBulkOperationErrorsDetails {
  message: string;
  reference: string;
}

export interface FileValidationResult {
  titles: string[];
  ignoredRows: IgnoredRow[];
}

export interface IgnoredRow {
  value: string[];
}

export enum StoreBulkOperationType {
  ChangeVariantUids = 'bulk_product_uid_change',
  BulkPriceChange = 'bulk_price_change',
  BulkProductVariantOptionsUpdate = 'bulk_product_variant_options_update',
  BulkCreateProductsFromTemplate = 'bulk_create_products_from_template',
  BulkProductExpandAndConnect = 'bulk_product_expand_and_connect',
  BulkVariantStatusUpdate = 'bulk_variant_status_update',
}

export interface StoreBulkOperationRequest {
  storeId: string;
  fileUrl: string;
  operationType: StoreBulkOperationType;
  isInstant: boolean;
  additionalParams: string;
}

export interface StoreBulkPriceChangeOperationTypeParams {
  skipUpdatedVariants: boolean;
  forceUpdate: boolean;
}

export interface StoreBulkCreateProductsFromTemplateOperationTypeParams {
  templateProductId: string;
  publishProducts: boolean;
  salesChannel?: string[];
  isVisibleInTheOnlineStore?: boolean;
}

export interface StoreBulkExpandAndConnectOperationTypeParams {
  templateProductId: string;
  publishProducts: boolean;
  variantIdsToDelete: string[];
}

export interface StoreBulkUpdateProductOptionsOperationTypeParams {
  publishProducts: boolean;
}

export interface StoreChangeProductUidFileMappingRequest {
  storeId: string;
  fileUrl: string;
}

export interface StoreChangeProductUidFileMappingResponse {
  storeId: string;
  productVariants: MappedVariants[];
}

export interface MappedVariants {
  sourceProductVariantId: string;
  destinationProductUid: string;
}

export type StoreBulkChangeOperationAdditionalParams =
  | StoreBulkPriceChangeOperationTypeParams
  | StoreBulkCreateProductsFromTemplateOperationTypeParams
  | StoreBulkExpandAndConnectOperationTypeParams
  | Record<string, any>;
